var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tiko-logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 668.4 385.4",
    style: {
      enableBackground: "new 0 0 668.4 385.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.5,179.6v144.9h44.8V143c-2.5-0.3-5-0.4-7.6-0.4C213,142.6,194.5,150.6,194.5,179.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M514.9,138.9c-53.4,0-96.8,42.5-96.8,94.9c0,52.4,43.4,94.9,96.8,94.9c53.4,0,96.8-42.5,96.8-94.9 C611.7,181.4,568.3,138.9,514.9,138.9z M514.9,291.4c-29.6,0-53.6-25.8-53.6-57.6c0-31.8,23.9-57.6,53.6-57.6 c29.6,0,53.6,25.8,53.6,57.6C568.5,265.6,544.5,291.4,514.9,291.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M219.6,56.7c-15.4,0-27.9,12.5-27.9,27.9s12.5,27.8,27.9,27.8c15.3,0,27.8-12.4,27.8-27.8S235,56.7,219.6,56.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.8,290.8c-19.3,0-23.6-11.1-23.6-28v-80.7h16.9c25.3,0,32.2-16,32.2-32.4c0-2.3-0.2-4.4-0.4-6.6h-48.7v-51 H80.5v51H56.7v39h23.8v81.4c0,34,10.2,63.5,58.9,63.5c9.7,0,22.2-2,29.9-4.8l-1.6-35.1C162.6,289.4,154.6,290.8,148.8,290.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "438.6,324.5 361.3,225.7 437.4,143.1 379.7,143.1 313,219.7 313,57.8 268.2,57.8 268.2,324.5  313,324.5 313,227.1 384.5,324.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.37353fca57a2acbdb23a66232d22e5b2.svg";
export { ForwardRef as ReactComponent };